import { TProcType } from '../../../../types';
export var list = [
    TProcType.GENERAL,
    TProcType.CONSULTATION,
    TProcType.GESTION,
];
